import { PageContextUtils } from "./utils";

const { resourcesUrl } = PageContextUtils.getSiteData();

let url = resourcesUrl || "/";
url = url.endsWith("/") ? url : `${url}/`;
// eslint-disable-next-line no-undef
__webpack_public_path__ = url;
